document.addEventListener('DOMContentLoaded', function () {
    const EXPIRE_TYPE_SESSION = 'session';
    const EXPIRE_TYPE_DATE = 'date';

    const modalTriggerLink = document.querySelector('.js-newsletter-link');
    const ids = {
        IT: '672c82626d7c733983c45e99',
        others: '67330de5f692ad244ffa0b42',
    };
    const id = ids[window.Shopify.country] || ids['others'];
    const timeout = 60 * 1000; // default: 1 minute = 60 * 1000
    const expireDays = 30 * 24 * 60 * 1000; // default: 30 days = 30 * 24 * 60 * 1000

    function openOmnisendForm(id) {
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', id]);
    }

    modalTriggerLink?.addEventListener('click', () => {
        openOmnisendForm(id);
    });

    const canOpenModal = () => {
        if (window.NEWSLETTER_EXPIRE_TYPE === EXPIRE_TYPE_SESSION) {
            return window.sessionStorage.getItem('omnisend:closed') !== 'true';
        } else if (window.NEWSLETTER_EXPIRE_TYPE === EXPIRE_TYPE_DATE) {
            const closedTime = window.localStorage.getItem('omnisend:closedTime');
            return closedTime ? Date.now() > closedTime : true;
        }
    };

    if (canOpenModal()) {
        setTimeout(function () {
            openOmnisendForm(id);
        }, timeout);
    }

    window.addEventListener('omnisendForms', function (e) {
        if (e.detail.type === 'submit' || e.detail.type === 'close') {
            if (window.NEWSLETTER_EXPIRE_TYPE === EXPIRE_TYPE_SESSION) {
                window.sessionStorage.setItem('omnisend:closed', 'true');
            } else if (window.NEWSLETTER_EXPIRE_TYPE === EXPIRE_TYPE_DATE) {
                window.localStorage.setItem('omnisend:closedTime', Date.now() + expireDays);
            }
        }
    });
});
